import { useEffect, useState } from "react";
import { getCurrentUserProfile } from "../utils/profileCache";
import { extractOwnedCourseIds } from "../utils/ownedCourseIds";

/**
 * @returns {{ ownedCourseIds: string[], ownershipReady: boolean }}
 */
export function useOwnedCourseIds() {
  const [ownedCourseIds, setOwnedCourseIds] = useState([]);
  const [ownershipReady, setOwnershipReady] = useState(false);
  const userId = typeof localStorage === "undefined" ? "" : String(localStorage.getItem("idUsuario") || "");

  useEffect(() => {
    let cancelled = false;
    getCurrentUserProfile({ force: Boolean(userId) })
      .then((profile) => {
        if (!cancelled) {
          setOwnedCourseIds(extractOwnedCourseIds(profile));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setOwnedCourseIds([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setOwnershipReady(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { ownedCourseIds, ownershipReady };
}
